/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useState } from 'react';
import { Form, Input, Message, Modal, Upload } from '@arco-design/web-react';

import './index.scss';

import { API_CONFIG } from '../utils';
import { get, post } from '../requestNew';

const FormItem = Form.Item;

type Props = {
  openId: string;
  orderId: string;
  nickname: string;
  holdDate: string;
  visible: boolean;
  gameSession: string;
  onClose: () => void;
};

type UploadItem = {
  status: string;
  response: {
    code: number;
    data: string;
  };
};

function Capital(props: Props) {
  const { visible, orderId, openId, nickname, holdDate, gameSession, onClose } = props;
  const [init, setInit] = useState(false);
  const [addPrice, setAddPrice] = useState('');
  const [removePrice, setRemovePrice] = useState('');
  const [orderPicVos, setOrderPicVos] = useState<{ url: string; uid: string }[]>([]);

  const uploadImg = (res?: UploadItem) => {
    const { status, response } = res || {};
    if (status === 'done') {
      const { code, data = '' } = response || {};
      if (code === 200) {
        setOrderPicVos([{ url: data, uid: '1' }]);
      }
    }
  };

  const getData = () => {
    const params = {
      orderId,
      holdDate,
      gameSession
    };
    get('/sys/umsExplodeOrder/getOutInPriceDetail', params)
      .then((res: any) => {
        const { code, data } = res || {};
        if (code === 200) {
          const { addPrice, removePrice, orderPicVos = [] } = data;
          setAddPrice(addPrice);
          setRemovePrice(removePrice);
          setOrderPicVos(orderPicVos);
          setInit(true);
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  const submitCapital = () => {
    if (!addPrice && !removePrice) {
      Message.error('请先输入转入或转出资金');
      return;
    }
    if (!orderPicVos.length) {
      Message.error('请上传账户截图');
      return;
    }
    const data = {
      openId,
      orderId,
      nickname,
      addPrice: addPrice || 0,
      removePrice: removePrice || 0,
      orderPicVos,
      holdDate,
      picType: 2,
      isFront: 0,
      gameSession
    };
    post('/sys/umsExplodeOrder/addOutInPrice', data)
      .then((res: any) => {
        const { code, message } = res || {};
        if (code === 200) {
          Message.success('提交成功！');
          onClose();
        } else {
          Message.error(message);
        }
      })
      .catch(e => {
        Message.error('网络错误！');
        console.log(e);
      });
  };

  useEffect(() => {
    if (visible) {
      getData();
    } else {
      setInit(false);
      setAddPrice('');
      setRemovePrice('');
      setOrderPicVos([]);
    }
  }, [visible]);

  return (
    <Modal
      title="修改资金流入流出"
      visible={visible}
      onOk={() => submitCapital()}
      onCancel={onClose}
      unmountOnExit={true}
      maskClosable={false}
      autoFocus={false}
      focusLock={true}
    >
      <Form
        style={{ width: 400 }}
        labelCol={{ span: 8, offset: 0 }}
        wrapperCol={{ span: 16, offset: 0 }}
        autoComplete="off"
      >
        <FormItem label="今日转入资金">
          <Input
            value={addPrice}
            onChange={val => {
              setAddPrice(val);
            }}
            onBlur={() => {
              if (isNaN(+addPrice)) {
                setAddPrice('');
              }
            }}
          />
        </FormItem>
        <FormItem label="今日转出资金">
          <Input
            value={removePrice}
            onChange={val => {
              setRemovePrice(val);
            }}
            onBlur={() => {
              if (isNaN(+addPrice)) {
                setRemovePrice('');
              }
            }}
          />
        </FormItem>
        <FormItem field="orderPicVos" label="资金流进出截图">
          {init ? (
            <Upload
              key="init"
              name="file"
              listType="picture-card"
              imagePreview
              limit={1}
              defaultFileList={orderPicVos}
              action={API_CONFIG.uploadUrl}
              onChange={(res: any) => {
                uploadImg(res[0]);
              }}
            />
          ) : (
            <Upload
              key="uninit"
              name="file"
              listType="picture-card"
              imagePreview
              limit={1}
              action={API_CONFIG.uploadUrl}
              onChange={(res: any) => {
                uploadImg(res[0]);
              }}
            />
          )}
        </FormItem>
      </Form>
    </Modal>
  );
}

export default Capital;
